var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 40C44.4183 40 48 36.4183 48 32C48 27.5817 44.4183 24 40 24C35.5817 24 32 27.5817 32 32C32 36.4183 35.5817 40 40 40Z",
    stroke: "#94535C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40V48C32 50.1217 31.1571 52.1566 29.6569 53.6569C28.1566 55.1571 26.1217 56 24 56C21.8783 56 19.8434 55.1571 18.3431 53.6569C16.8429 52.1566 16 50.1217 16 48C16 45.8783 16.8429 43.8434 18.3431 42.3431C19.8434 40.8429 21.8783 40 24 40M32 40H24M32 40V24M24 40C21.8783 40 19.8434 39.1571 18.3431 37.6569C16.8429 36.1566 16 34.1217 16 32C16 29.8783 16.8429 27.8434 18.3431 26.3431C19.8434 24.8429 21.8783 24 24 24M32 24H24M32 24V8M32 24H40C42.1217 24 44.1566 23.1571 45.6569 21.6569C47.1571 20.1566 48 18.1217 48 16C48 13.8783 47.1571 11.8434 45.6569 10.3431C44.1566 8.84286 42.1217 8 40 8H32M24 24C21.8783 24 19.8434 23.1571 18.3431 21.6569C16.8429 20.1566 16 18.1217 16 16C16 13.8783 16.8429 11.8434 18.3431 10.3431C19.8434 8.84286 21.8783 8 24 8H32",
    stroke: "#94535C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.6a6f94c71d9094c1dbf1fe2d47010d71.svg";
export { ForwardRef as ReactComponent };